import { Link } from "react-router-dom";
import type { Anime } from "@/types";
import Badge from "./Badge";

interface AnimeCardProps {
  anime: Anime;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={`《${anime.title}》动画封面`}
          title={`${anime.title} 动画推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-full bg-accent-500/95 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {anime.rating.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {anime.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 group-hover:text-primary-700">
          {anime.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">
          {anime.description}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          <Badge tone="secondary">{anime.year}</Badge>
          <Badge tone="neutral">{anime.region}</Badge>
          {anime.genre.slice(0, 1).map((genre) => (
            <Badge key={genre} tone="primary">
              {genre}
            </Badge>
          ))}
        </div>
      </div>
    </Link>
  );
}